import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './components/assets/css/theme.min.css';
import './components/assets/css/user.min.css';
import DefaultLayout from './components/layouts/DefaultLayout';
import LoginLayout from './components/layouts/LoginLayout';
import { useAuthContext } from './components/AuthProvider';


const App = () => {

    const { loginUser } = useAuthContext();

    return loginUser !== null ? <DefaultLayout /> :<LoginLayout />;
}

export default App;
